import { getCdsGUIElements } from '@/services/importingJsons.js'

const combineDataSources = {
  namespaced: true,
  state: {
    cdsElements: {
      objects: {},
      loading: false,
      error: false
    },
    selected: {
      sourceToCombine: null,
      outputTypes: null,
      customReportLink: null
    }
  },
  mutations: {
    cdsElements (state, payload) {
      state.cdsElements[payload.prop] = payload.value
    },
    selected (state, payload) {
      state.selected[payload.propName] = payload.value
    },
    setDefaultState (state) {
      state.postReport = {
        error: false,
        loading: false,
        response: null
      }
    },
    overwriteSelected (state, newVal) {
      state.selected = newVal
    },
    setDefaultSelectionState (state) {
      state.selected = {
        sourceToCombine: null,
        outputTypes: null,
        customReportLink: null
      }
    }
  },
  getters: {
    getAllSelections: state => {
      return state.selected
    }
  },
  actions: {
    loadOCdsElementsObjects ({ commit }) {
      commit('cdsElements', { prop: 'loading', value: true })
      commit('cdsElements', { prop: 'error', value: false })
      getCdsGUIElements().then(response => {
        commit('cdsElements', { prop: 'objects', value: response })
      }).catch(error => {
        console.error('LoadOCdsElementsObjects:cdsElements: ', error)
        commit('cdsElements', { prop: 'error', value: true })
      }).finally(() => {
        commit('cdsElements', { prop: 'loading', value: false })
      })
    },
    loadStateFromFile ({ commit }, data) {
      commit('overwriteSelected', data)
    },
    updateSelection ({ commit }, payload) {
      commit('selected', payload)
    },
    reset ({ commit }) {
      commit('setDefaultState')
      commit('setDefaultSelectionState')
    }
  }
}
export default combineDataSources
